import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-confirm-big-search-dialog",
  templateUrl: "./confirm-big-search-dialog.component.html",
  styleUrls: ["./confirm-big-search-dialog.component.scss"],
})
export class ConfirmBigSearchDialogComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
